import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './cookie-consent.css';
import 'vanilla-cookieconsent';

const NO_COOKIE_CONSENT_COUNTRIES = ['US'];

function shouldShowCookieConsent() {
  const user = window.__TGV_USER_DATA;

  // never show in VC
  if (window.location.href.includes('/venue-cabinet/')) {
    return false;
  }

  // if we cannot determine user country, we should show cookie consent
  if (!user) {
    return true;
  }

  return !NO_COOKIE_CONSENT_COUNTRIES.includes(user.locationCountryCode);
}

function showCookiesBanner() {
  const root = document.querySelector('#gdpr-banner');
  const cc = window.initCookieConsent(root);

  const config = {
    revision: 1,
    current_lang: 'en',
    autoclear_cookies: true,
    remove_cookie_tables: false,
    page_scripts: true,
    delay: 0,
    mode: 'opt-out',
    onAccept(settings) {
      // clear loaded GA if no analytics permission granted
      if (settings.level.indexOf('analytics') === -1) {
        window.dataLayer = [];
      }
    },
    gui_options: {
      consent_modal: {
        layout: 'cloud',
        position: 'bottom center',
        transition: 'slide',
        swap_buttons: false,
      },
      settings_modal: {
        layout: 'box',
        transition: 'slide',
      },
    },
    languages: {
      en: {
        consent_modal: {
          title: 'We value your privacy',
          description: 'We use cookies and similar technologies to help personalise content and provide a better experience. By clicking OK you agree to this and our <a href="https://www.tagvenue.com/page/cookie-policy" class="cc-link">Cookie Policy</a>. To change preferences or withdraw consent, please update your Cookie Preferences.',
          primary_btn: {
            text: 'OK',
            role: 'accept_all',
          },
          secondary_btn: {
            text: 'Cookie preferences',
            role: 'settings',
          },
        },
        settings_modal: {
          title: 'Cookie preferences',
          save_settings_btn: 'Save settings',
          accept_all_btn: 'Accept all',
          reject_all_btn: 'Reject all',
          close_btn_label: 'Close',
          cookie_table_headers: [
            { col1: 'Name' },
          ],
          blocks: [
            {
              title: 'Cookie usage',
              description: `We use cookies and similar technologies to help personalise content and provide a better
experience. By clicking OK you agree to this and our <a href="https://www.tagvenue.com/page/cookie-policy"
 class="cc-link">Cookie Policy</a>. To change preferences or withdraw consent, please update your Cookie Preferences.`,
            }, {
              title: 'Strictly necessary cookies',
              description: `These cookies are necessary for the website to function and can't be switched off in our
               systems. They are usually only set in response to actions you have taken which result in a request for
               services, such as setting your privacy preferences, logging in or filling in forms. You can set your
               browser to block or alert you about these cookies, but some parts of the site may not work as a result.`,
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true,
              },
            }, {
              title: 'Performance and Analytics cookies',
              description: 'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. If you do not allow these cookies, information from these cookies will not be used to help site performance.',
              toggle: {
                value: 'analytics',
                enabled: true,
                readonly: false,
              },
              cookie_table: [
                {
                  col1: '^_ga',
                  is_regex: true,
                },
                {
                  col1: '_gid',
                },
                {
                  col1: '^_dc_gtm',
                  is_regex: true,
                },
                {
                  col1: '^_hj',
                  is_regex: true,
                },
                {
                  col1: '^mp_',
                  is_regex: true,
                },
              ],
            },
          ],
        },
      },
    },
  };

  cc.run(config);
}

window.addEventListener('load', () => {
  window.jQuery?.subscribe?.('TGV_USER_DATA', () => {
    const settingsExist = document.cookie.includes('cc_cookie');
    if (!shouldShowCookieConsent() || settingsExist) {
      return;
    }

    showCookiesBanner();
  }, { immediate: true });
});
